<div class="pr-3 pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Danh sách phiếu khảo sát&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button class="flex items-center justify-center text-blue-600" nz-button nzTooltipTitle="In"
          nzTooltipPlacement="bottom" nz-tooltip (click)="handlerPrint()">
          <i nz-icon nzType="printer" nzTheme="outline"></i>
        </button>
        <button class="flex items-center justify-center text-green-600" nz-button nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="handlerExcel()">
          <i nz-icon nzType="file-excel" nzTheme="outline"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button class="flex items-center justify-center" nz-button (click)="handlerPrint()">In
        </button>
        <button class="flex items-center justify-center" nz-button (click)="handlerExcel()">Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button class="flex items-center justify-center" nz-button (click)="handlerPrint()">
          <i nz-icon nzType="printer" nzTheme="outline"></i>
          In
        </button>
        <button class="flex items-center justify-center" nz-button (click)="handlerExcel()">
          <i nz-icon nzType="file-excel" nzTheme="outline"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Năm</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}" (nzOnOpenChange)="changeYear()" nzPlaceHolder="Nhập năm"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Loại khảo sát</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-select nzShowSearch nzAllowClear  [(ngModel)]="commonFilter.StudentSurveyType" [ngModelOptions]="{standalone: true}">
              <nz-option [nzValue]="0" nzLabel="Khảo sát dành cho người khuyết tật"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Trạng thái</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-select nzShowSearch nzAllowClear  [(ngModel)]="commonFilter.StudentSurveyStatus" [ngModelOptions]="{standalone: true}">
              <nz-option [nzValue]="0" nzLabel="Chưa đánh giá"></nz-option>
              <nz-option [nzValue]="1" nzLabel="Đã đánh giá"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse">
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6"></div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Họ tên</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <input nz-input [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}" type="text"
                placeholder="Nhập" aria-label="Search" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Giới tính</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="null">Tất cả</label>
                <label nz-radio [nzValue]="1">Nam</label>
                <label nz-radio [nzValue]="0">Nữ</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </ng-container>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
        nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
             
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table
      [nzShowTotal]="rangeTemplate"
      #Table
      nzOuterBordered
      nzShowSizeChanger
      [nzData]="dataList"
      [nzFrontPagination]="false"
      nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}"
      class="absolute w-full"
      [nzTotal]="Total"
      [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)"
      (nzPageSizeChange)="pageSizeEvent($event)"
      [nzShowTotal]="rangeTemplate"
      >
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft>STT</th>
          <th nzWidth="200px" nzLeft>Loại khảo sát</th>
          <th nzWidth="250px">Họ tên</th>
          <th nzWidth="80px">Giới tính</th>
          <th nzWidth="200px">Ngày sinh</th>
          <th>Trạng thái</th>
          <th nzWidth="80px" nzRight></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index ">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{ data.studentSurveyType == 0 ? "Khảo sát dành cho người khuyết tật" : ""  }}</td>
          <td>{{ data.fullName }}</td>
          <td>{{ data.gender | gender}}</td>
          <td>{{ data.yearOfBirth}}</td>
          <td>{{ data.studentSurveyStatus == 0 ? "Chưa đánh giá" : "Đã đánh giá"}}</td>
          <td nzRight>
            <div class="flex items-center justify-center" >
                <a class="text-blue-600 mr-2 flex items-center" nzTooltipTitle="Thực hiện đánh giá" nzTooltipPlacement="top" nz-tooltip   [routerLink]="['../phieudanhgiankt', data.id]" >
                  <i class="fa fa-id-card-o"></i>
                </a>
                <!-- <a class="text-green-600" nzTooltipTitle="Xem chi tiết phiếu khảo sát" nzTooltipPlacement="top" nz-tooltip
                  (click)="showDeTail(data)">
                  <i class="far fa-id-card"></i>
                </a> -->
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span> {{ titlePopup }}</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>
